import React, { Component } from 'react';
import './App.css';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import About from './components/About';
import Contact from './components/Contact';
import Livebarn from './components/Livebarn';
import Calendar from './components/Calendar';
import Cart from './components/Cart';
import Login from './components/Login';
import Logout from './components/Logout';
import Register from './components/Register';
import VerifyEmail from './components/VerifyEmail';
import RegistrationSuccess from './components/RegistrationSuccess';
import ArenaDisplay from './components/ArenaDisplay';
import Event from './components/Event';
import NewEvent from './components/NewEvent';
import NewSeries from './components/NewSeries';
import AdminEvent from './components/AdminEvent';
import { Header } from './components/Header'
import './assets/style/app.css';
import './assets/style/signin.css';
import './assets/style/bootstrap-social.css';
import './assets/style/_base.scss';
import Favicon from 'react-favicon';
import { connect } from 'react-redux';
import { updateUser } from './actions/user-actions';
import { updateAlert } from './actions/alert-actions';
import Admin from './components/Admin';
import Rooms from './components/Rooms';
import RoomAdmin from './components/RoomAdmin';

class App extends Component {
  constructor(props) {
    super(props);

  }
/*
  onUpdateUser(token){
    console.log('updating... in App');
    this.props.onUpdateUser(token);
  }
*/
  render() {
    console.log(this.props)
    return (
      <Router>
        <div>
          <Favicon url="assets/images/bi.png"/>
          <Header />
          <Switch>
              <Route exact path='/' component={Calendar} />
              <Route path='/contact' component={Contact} />
              <Route path='/livebarn' component={Livebarn} />
              <Route path='/about' component={About} />
              <Route path='/calendar' component={Calendar} />
              <Route path='/cart' component={Cart} />
              <Route path='/login' component={Login} />
              <Route path='/logout' component={Logout} />
              <Route path='/register' component={Register} />
              <Route path='/registration_success' component={RegistrationSuccess} />
              <Route path='/display2' component={ArenaDisplay} />
              <Route path='/scheduler' component={Calendar} /> 
              <Route path='/event/:id/rooms' component={Rooms} />                           
              <Route path='/event/:id' component={Event} />
              <Route exact path='/newEvent/:start/:end' component={NewEvent} />
              <Route path='/newEvent' component={NewEvent} />
              <Route exact path='/newSeries/:start/:end' component={NewSeries} />
              <Route path='/newSeries' component={NewSeries} />
              <Route path='/verifyEmail/:id' component={VerifyEmail} />
              <Route path='/admin/rooms' component={RoomAdmin} />
              <Route path='/admin/event/:id' component={AdminEvent} />   
              <Route path='/admin' component={Admin} />

          </Switch>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  products: state.products,
  user: state.user,
  alert: state.alert,
});
/*
const mapActionsToProps = {
  onUpdateUser: updateUser
};
*/
export default connect(mapStateToProps
//    mapActionsToProps
  )(App);



// WEBPACK FOOTER //
// ./src/App.js